import { storyblok } from "../lib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

function createMarkup(storyblokHTML) {
  return {
    __html: storyblok.richTextResolver.render(storyblokHTML)
  };
}

var RichText = data => {
  return data ? /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: createMarkup(data)
  }) : /*#__PURE__*/_jsx(_Fragment, {});
};

export default RichText;
//# sourceMappingURL=richText.js.map